import PropTypes from 'prop-types'
import React from 'react'
import FontAwesome from 'react-fontawesome'
import styled from 'styled-components'

const StyledAccordion = styled.div`
	cursor: pointer;

	.accordion {
		&-item {
			&-header {
				&-icon {
					transition: transform 0.5s ease-in-out;
				}
				&-title {
					width: 100%;
				}
			}

			&-content {
				${props =>
					props.noAnimated
						? ''
						: 'transition: all 0.2s ease-in-out;'} overflow: hidden;
				max-height: 0px;
			}

			&.open {
				.accordion-item {
					&-header {
						margin-bottom: 2rem;

						&-icon {
							transform: rotate(180deg);
						}
					}

					&-content {
						margin-top: 2rem;
						max-height: 9999px;
						overflow: unset;
					}
				}
			}
		}
	}
`

const AccordionItem = ({
	item,
	isOpen,
	onClick,
	index,
	arrow,
	noAnimated,
	identifier
}) => {
	const getItemClassName = () => `accordion-item ${isOpen ? 'open' : ''}`
	return (
		<StyledAccordion
			id={`accordion-${index}${
				identifier === undefined ? '' : '-' + identifier
			}`}
			noAnimated={noAnimated}>
			<div className={getItemClassName()}>
				<div className="accordion-item-header" onClick={onClick}>
					<div className="accordion-item-header-title">
						<span>{item.title}</span>
					</div>
					{arrow && (
						<FontAwesome
							className="accordion-item-header-icon"
							name="angle-down"
						/>
					)}
				</div>
				<div className="accordion-item-content">{item.content}</div>
			</div>
		</StyledAccordion>
	)
}

/**
 *
 * @param {array} items
 * The items to show as accordion-items. template: { title, content }
 *
 * @param {boolean} arrow
 * Shows the arrow in accordion-item
 *
 * @param {boolean} noClickable
 * Disable the click in accordion-item
 *
 * @param {boolean} noAnimated
 * Disbale animate transitions
 *
 */
export default class Accordion extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			isOpen: this.props.items.map(({ initiallyOpened }, index) =>
				initiallyOpened === undefined ? index === 0 : initiallyOpened
			)
		}
	}

	componentWillReceiveProps(nextProps) {
		if (
			nextProps.items.length != this.props.items.length ||
			this.state.isOpen.length == 0
		) {
			this.setState({
				isOpen: this.props.items.map(({ initiallyOpened }, index) =>
					initiallyOpened === undefined ? index === 0 : initiallyOpened
				)
			})
		}
	}

	toggleItem = index => {
		this.state.isOpen[index] ? this.closeItem(index) : this.openItem(index)
	}

	closeItem = index =>
		this.setState({
			isOpen: this.state.isOpen.map((item, i) =>
				i === index ? false : item
			)
		})

	openItem = index => {
		this.setState({
			isOpen: this.state.isOpen.map((item, i) => (i === index ? true : item))
		})
	}

	openJustTheItem = index => {
		this.setState({
			isOpen: this.state.isOpen.map((item, i) =>
				i === index ? true : false
			)
		})
	}

	openAll = () =>
		new Promise(resolve =>
			this.setState(
				{
					isOpen: this.state.isOpen.map(() => true)
				},
				resolve
			)
		)

	open = index => {
		this.props.multiple ? this.toggleItem(index) : this.openJustTheItem(index)
	}

	setFocus = title => {
		if (title === 'Endereço') {
			document.getElementById('state').focus()
			window.scrollTo(0, 250)
		}
		if (title === 'Dados complementares') {
			document.getElementById('birthday').focus()
			window.scrollTo(0, 250)
		}
		if (title === 'Senha') {
			document.getElementById('password').focus()
			window.scrollTo(0, 385)
		}
		if (title === 'Termos e condições de uso') {
			document.getElementById('newsletter').focus()
			window.scrollTo(0, 400)
		}
	}

	render() {
		const { items, arrow, noClickable, noAnimated, identifier } = this.props
		return (
			<div className="accordion">
				{items.map((item, index) => (
					<AccordionItem
						key={index}
						item={item}
						arrow={arrow}
						index={index}
						noAnimated={noAnimated}
						isOpen={this.state.isOpen[index]}
						identifier={identifier}
						onClick={() => {
							noClickable
								? null
								: (this.open(index),
								  this.setFocus(item.title),
								  item.onClick && item.onClick())
						}}
					/>
				))}
			</div>
		)
	}
}

Accordion.propTypes = {
	items: PropTypes.array.isRequired,
	arrow: PropTypes.bool,
	noClickable: PropTypes.bool,
	noAnimated: PropTypes.bool
}
